export function setStatic(key, value) {
    return {
        staticCallback: function (componentClass) {
            componentClass[key] = value;
        },
    };
}
export default setStatic;

//# sourceMappingURL=setStatic.js.map



//////////////////
// WEBPACK FOOTER
// ./node_modules/reassemble/lib/setStatic.js
// module id = 41
// module chunks = 0